import React from 'react';

import { Box, Modal, Typography } from '@mui/material';

import { useModal } from '../../../../utils/hooks';
import JoinNowModal from '../../../SingleVideoPage/components/JoinNowModal';
import PathwayVideoCard from '../PathwayVideoCard';
import useStyles from './styles';

const PathwayVideos = ({ videos, pathwayTitle, isLoggedIn }) => {
  const classes = useStyles();

  const { openModal, handleCloseModal, handleOpenModal } = useModal();

  return (
    <>
      <Box className={classes.wrapper}>
        <Typography data-testid="totalDuration" className={classes.title}>
          {pathwayTitle}
        </Typography>
        <ul className="pathway-list">
          {videos.map((video) => (
            <li key={video?.id}>
              <PathwayVideoCard
                video={video}
                handleOpenJoinModal={!isLoggedIn ? handleOpenModal : null}
              />
            </li>
          ))}
        </ul>
      </Box>
      {!isLoggedIn && (
        <Modal className={classes.modal} open={openModal}>
          <JoinNowModal handleClose={() => handleCloseModal()} isLoggedIn={isLoggedIn} />
        </Modal>
      )}
    </>
  );
};

export default PathwayVideos;
